"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var DEFAULT_QUILL_DELTA = {
    ops: [
        {
            insert: '\n'
        }
    ]
};
var PageHeaderFooterOptionsService = /** @class */ (function () {
    function PageHeaderFooterOptionsService() {
        this.headerContents = lodash_1.default.cloneDeep(DEFAULT_QUILL_DELTA);
        this.footerContents = lodash_1.default.cloneDeep(DEFAULT_QUILL_DELTA);
        this.isSaveInProgress = false;
    }
    PageHeaderFooterOptionsService.prototype.getContents = function (headerFooter) {
        return headerFooter === 'header' ? this.headerContents : this.footerContents;
    };
    PageHeaderFooterOptionsService.prototype.setContents = function (headerFooter, value) {
        if (headerFooter === 'header') {
            this.headerContents = value;
        }
        else {
            this.footerContents = value;
        }
    };
    PageHeaderFooterOptionsService.prototype.setSaveInProgress = function (value) {
        this.isSaveInProgress = value;
    };
    PageHeaderFooterOptionsService.prototype.isSavingInProgress = function () {
        return this.isSaveInProgress;
    };
    return PageHeaderFooterOptionsService;
}());
(function (angularModule) {
    angularModule.service('prPageHeaderFooterOptionsService', PageHeaderFooterOptionsService);
})(angular_1.module('qualtrics.pr'));
